<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
  }
</script>
<style>
    html, body {
        height: 100%;
        min-height: 100%;
    }

    #app {
        height: 100%;
    }

    body .el-table th.gutter {
        display: table-cell !important;
    }

    .input-box .el-input__inner {
        text-indent: 20px;
    }

    #Novel_Details .el-cascader__tags {
        display: inline-block !important;
        line-height: 30px !important;
    }
</style>
